import http from "@/http/aisea/axios";
const resource = "/enterprises/manning/vessels/statuses";

/**
 * 船舶動静種別（法人・乗組員管理の船舶ステータス）API
 */
export default {
  /**
   * 船舶動静種別一覧取得
   * @returns {Promise<{ data: { list: Array } }>}
   */
  fetch() {
    return http.get(`${resource}`);
  },

  /**
   * 船舶動静種別登録
   * @param {Object} payload - { color_hex, default_minutes, name, show_on_creating, sort_order }
   * @returns {Promise}
   */
  create(payload) {
    return http.post(`${resource}`, payload);
  },

  /**
   * 船舶動静種別更新
   * @param {string} enterpriseManningVesselStatusId
   * @param {Object} payload - { color_hex, default_minutes, name, show_on_creating, sort_order }
   * @returns {Promise}
   */
  update(enterpriseManningVesselStatusId, payload) {
    return http.put(
      `${resource}/${enterpriseManningVesselStatusId}`,
      payload
    );
  },
};
